// packages import
import { FC, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

// others
import ReferralTypeDropdown from '../../referralSources/ReferralTypeDropdown'
import { QUERY_PARAMS } from '../../../constants'

interface ReferralTypeFilterProps {
  setReportFilters: React.Dispatch<React.SetStateAction<Record<string, any>>>
}

const ReferralTypeFilter: FC<ReferralTypeFilterProps> = ({ setReportFilters }) => {
  const [searchParams] = useSearchParams()
  const referralType = searchParams.get(QUERY_PARAMS.SOURCE_TYPE)

  useEffect(() => {
    if (referralType === null) return

    if (referralType === QUERY_PARAMS.ALL) {
      setReportFilters((prev: any) => {
        const newFilters = { ...prev }
        delete newFilters.referralType
        return newFilters
      })
    } else {
      setReportFilters((prev: any) => ({ ...prev, referralType }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referralType])

  return <ReferralTypeDropdown />
}

export default ReferralTypeFilter
